import { Provider } from '@angular/core';
import { SearchApi } from './search.api';
import { RotorApi } from './rotor.api';
import { SettingsApi } from './settings.api';
import { FilterApi } from './filter.api';
import { ReportTemplateApi } from './report-template.api';
import { environment } from 'src/environment/environment';
import { API_BASE_URL, US_BASE_URL } from './tokens';

export * from './rotor.api';
export * from './search.api';
export * from './settings.api';
export * from './filter.api';
export * from './report-template.api';
export const apiProviders: Provider[] = [
  SearchApi,
  RotorApi,
  SettingsApi,
  FilterApi,
  ReportTemplateApi,
  { provide: API_BASE_URL, useValue: environment.apiBaseUrl },
  { provide: US_BASE_URL, useValue: environment.usBaseUrl },
];
